import apiClient from "../axios";

export type ReleaseNotes = {
    version: string;
    min_app_version: string;
    url: string;
    message: string;
    acknowledged: boolean;
};

export const api = {
    getReleaseNotes: (version?: string) => {
        const url = version
            ? `/notifications/release-notes?version=${encodeURIComponent(version)}`
            : `/notifications/release-notes`;
        return apiClient.get<ReleaseNotes>(url).then((res) => res.data);
    },
    acknowledgeReleaseNotes: (version: string) => {
        return apiClient
            .post(`/notifications/release-notes/${encodeURIComponent(version)}/acknowledge`)
            .then((res) => res.data);
    },
};
